import { COMMON_TRANSLATION_KEYS } from "constants/commonTranslationsKeys";
import { lazyRetryWithPreload } from "utils/lazyRetryWithPreload";

import { PAGE_URLS } from "../constants/PageUrls";
import { BACKOFFICE_PERMISSIONS } from "../constants/Permissions";
import { BACKOFFICE_ACCESS_PERMISSIONS } from "../constants/Sections";

import type { Route } from "routes/RouteModel";

const Transactions = lazyRetryWithPreload(
  () => import("../pages/Transactions"),
  "BackofficeTransactions"
);

const TransactionDetails = lazyRetryWithPreload(
  () => import("../pages/TransactionDetails"),
  "BackofficeTransactionDetails"
);

export const accountsBackofficeRoutes: Route[] = [
  // The base URL forwards to the first section the user may open (see
  // useBuildChildRoutes), so the sidebar entry never lands on a section the
  // user has no permission for
  {
    path: PAGE_URLS.base,
    showChildrenInSidebar: true,
    can: { or: BACKOFFICE_ACCESS_PERMISSIONS },
    children: [
      {
        title: [
          COMMON_TRANSLATION_KEYS.accountsBackoffice,
          COMMON_TRANSLATION_KEYS.transactions,
        ],
        path: PAGE_URLS.transactions,
        component: Transactions,
        can: BACKOFFICE_PERMISSIONS.transactionsList,
        children: [
          {
            title: [
              COMMON_TRANSLATION_KEYS.accountsBackoffice,
              COMMON_TRANSLATION_KEYS.transactions,
              COMMON_TRANSLATION_KEYS.details,
            ],
            path: PAGE_URLS.transactionDetails,
            component: TransactionDetails,
            can: BACKOFFICE_PERMISSIONS.transactionDetails,
          },
        ],
      },
    ],
  },
];
